/*
 * BLOOM cart drawer (snippets/cart-drawer.liquid):
 * - the reservation timer counts down from the minutes set in Theme settings > Cart. It starts the first time the cart
 *   shows lines, keeps going across pages of the same visit and starts again once the cart is emptied;
 * - the item count in the header follows cart updates that only re-render the lines.
 */
(function () {
  if (window.customCartDrawer) return;
  window.customCartDrawer = true;

  var START_KEY = 'custom-cart-timer-start';
  // Also kept in memory, so the timer still works when sessionStorage is blocked
  var memoryStart = 0;

  function storage(action, value) {
    try {
      if (action === 'get') return window.sessionStorage.getItem(START_KEY);
      if (action === 'set') window.sessionStorage.setItem(START_KEY, value);
      if (action === 'clear') window.sessionStorage.removeItem(START_KEY);
    } catch (error) {}
    return null;
  }

  function reset() {
    storage('clear');
    memoryStart = 0;
  }

  function pad(number) {
    return (number < 10 ? '0' : '') + number;
  }

  function tick() {
    var timers = document.querySelectorAll('[data-cart-timer]');
    // The timer only renders while the cart has lines, so an empty cart starts the next one from zero
    if (!timers.length) {
      if (document.querySelector('cart-drawer.is-empty')) reset();
      return;
    }
    var start = parseInt(storage('get'), 10) || memoryStart;
    if (!start) {
      start = Date.now();
      storage('set', String(start));
    }
    memoryStart = start;
    timers.forEach(function (timer) {
      var label = timer.querySelector('[data-cart-timer-text]');
      if (!label) return;
      var total = (parseInt(timer.dataset.minutes, 10) || 10) * 60;
      var left = Math.max(0, total - Math.floor((Date.now() - start) / 1000));
      var text;
      if (left > 0) {
        text = (timer.dataset.text || '').replace('{time}', pad(Math.floor(left / 60)) + ':' + pad(left % 60));
      } else {
        text = timer.dataset.expired || '';
      }
      timer.classList.toggle('is-expired', left === 0);
      timer.classList.add('is-ready');
      if (label.textContent !== text) label.textContent = text;
    });
  }

  tick();
  window.setInterval(tick, 1000);

  // Every re-render paints the timer at its full length: correct it before the browser shows it
  var drawer = document.querySelector('cart-drawer');
  if (drawer && typeof MutationObserver === 'function') {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          tick();
          return;
        }
      }
    }).observe(drawer, { childList: true, subtree: true });
  }

  function countLabel(count) {
    return '(' + count + (count === 1 ? ' artículo' : ' artículos') + ')';
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cart = event && event.cartData;
      if (!cart || typeof cart.item_count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach(function (count) {
        count.textContent = countLabel(cart.item_count);
      });
      if (cart.item_count === 0) reset();
    });
  }
})();
